import { render, staticRenderFns } from "./DataViewSidebarSchools.vue?vue&type=template&id=ec630344&scoped=true"
import script from "./DataViewSidebarSchools.vue?vue&type=script&lang=js"
export * from "./DataViewSidebarSchools.vue?vue&type=script&lang=js"
import style0 from "./DataViewSidebarSchools.vue?vue&type=style&index=0&id=ec630344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec630344",
  null
  
)

export default component.exports